import { Pipe, PipeTransform } from '@angular/core';
import { getTripOwnerId } from '../../trip-owner';

@Pipe({
  name: 'isTripOwner',
  standalone: true,
})
export class IsTripOwnerPipe implements PipeTransform {
  #ownerId = getTripOwnerId();

  transform(userId: string): boolean {
    return this.#ownerId === userId;
  }
}
